export enum AlertVariant {
  SUCCESS = 'success',
  CONFIRM = 'confirm',
  WARNING = 'warning',
  MODIFICATION = 'modification',
  CLASSROOM_ARCHIVE = 'classroom-archive',
  DELETE = 'delete'
}
